/**
 * One place to react to a 401 from any API call (new or legacy helper).
 * The app shell registers the handler; repeated 401s only trigger it once.
 */
let handler = null;
let fired = false;

export function setSessionExpiredHandler(fn) {
  handler = fn;
  fired = false;
}

export function notifyUnauthorized() {
  if (fired || !handler) return;
  fired = true;
  handler();
}
